module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Semibold-29148e361e91ed0616630142caba9593.svg";